import TradingTerminalPage from '@/modules/dashboard/trading-terminal/trading-terminal-page';
import { requireCapability } from '@/utils/route-guards';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/trading-terminal/')(
  {
    beforeLoad: () => requireCapability('placeOrders'),
    component: RouteComponent,
  },
);

function RouteComponent() {
  return <TradingTerminalPage />;
}
